import { LDFlagValue } from 'launchdarkly-js-client-sdk';

import { DEFAULT_FLAG_VARIATIONS } from '../constants/flag-source.constants';

export class FlagUtils {
    /* immediate events emission */
    static flush(): void {
        (window as any)['ldClient'] && (window as any)['ldClient'].flush();
    }

    static getFlagVariation(flagKey: string, defaultValue: LDFlagValue): LDFlagValue {
        return (window as any)['ldClient'] && (window as any)['ldClient'].variation(flagKey, defaultValue);
    }

    static isValidVariation(flagKey: string, variations: string[] = []): boolean {
        const variationValue = this.getFlagVariation(flagKey, DEFAULT_FLAG_VARIATIONS[flagKey]);
        return variations && variations.includes(variationValue?.toString() || '');
    }

    static track(key: string, data?: any, metricValue?: number): void {
        (window as any)['ldClient'] && (window as any)['ldClient'].track(key, data, metricValue);
        FlagUtils.flush();
    }
}
